import {BranchSearchLazy} from 'app/components/branchSearch/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineBranchSearch(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-branch-search')) {
        return;
    }

    customElements.define(
        'gem-branch-search',
        class extends WebComponentLoader {
            reactLazyComponent = BranchSearchLazy;
        },
    );
}
